// PsyPractice — hukuki belgeler / Русский.
//
// Bölüm sırası, başlık numaraları ve hukuki iddialar TÜM dillerde aynıdır; esasa
// ilişkin bir değişiklik bütün dillerde birlikte yapılır ve shared.ts'teki
// LEGAL_VERSION birlikte artar — aksi hâlde kullanıcının onayladığı sürüm ile
// okuduğu metin ayrışır. Yalnızca çeviri eklemek sürümü ARTIRMAZ.
import { LEGAL_VERSION, MERCHANT, type LegalDoc } from "./shared";

// İşletme türünün ADI dile bağlıdır, resmî bilgiler (ad, adres, vergi) değildir —
// bu yüzden shared.ts'te değil, her dilin kendi dosyasında durur.
const OWNER_TYPE = "Индивидуальный предприниматель";

const OWNER = 'PsyPractice (далее — «Платформа» или «Оператор данных»)';

export const DOCS: LegalDoc[] = [
  {
    id: "terms",
    title: "Условия использования и отказ от ответственности",
    description:
      "Характер и границы услуги, что она не заменяет, обязательства пользователя и полный отказ от ответственности, возлагающий её на пользователя.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Стороны и принятие",
        paras: [
          `Настоящие Условия использования заключаются между ${OWNER} и любым физическим или юридическим лицом, которое получает доступ к Платформе или использует её (далее — «Пользователь»). Создавая учётную запись, выполняя вход или используя Платформу любым способом, Пользователь подтверждает, что прочитал, понял и безоговорочно принимает настоящие Условия в полном объёме и обязуется их соблюдать. Тот, кто не принимает настоящие Условия, не должен пользоваться Платформой.`,
        ],
      },
      {
        heading: "2. Характер и границы услуги",
        bullets: [
          "PsyPractice — это программное обеспечение для СИМУЛЯЦИИ пациента с использованием искусственного интеллекта, которое позволяет студентам-психологам и начинающим клиницистам вести и фиксировать собственную практику клинической беседы в безопасной среде.",
          "PsyPractice не является образовательной или преподавательской услугой; это программный инструмент, который позволяет пользователю вести и фиксировать собственную практику. Платформа не предоставляет занятий, учебных программ, экзаменов или документов и не присваивает никаких званий, квалификаций или полномочий.",
          "Смоделированный «пациент» не является реальным клиентом; его ответы синтезированы искусственным интеллектом, могут быть ошибочными, неполными, противоречивыми или вводящими в заблуждение и не претендуют на клиническую точность или достоверность.",
        ],
      },
      {
        heading: "2.1. Что Платформа не заменяет",
        bullets: [
          "Она НЕ является реальной терапией или консультированием и не заменяет ни одной сессии, проведённой с реальным клиентом.",
          "Она НЕ заменяет клиническую супервизию. Отчёты обратной связи, создаваемые ИИ-супервизором, — это автоматически сгенерированный текст; они не являются экспертным заключением, официальной оценкой или отметкой.",
          "Она НЕ является диагностическим, скрининговым или оценочным инструментом; никакой результат работы Платформы не может использоваться для постановки диагноза или принятия клинических решений в отношении реального человека.",
          "Её НЕЛЬЗЯ использовать в кризисных или неотложных ситуациях. При суицидальных мыслях, риске причинения вреда себе или другим либо в любой сопоставимой чрезвычайной ситуации закройте Платформу и немедленно обратитесь в местную экстренную службу или компетентное медицинское учреждение.",
          "Она НЕ является источником профессиональной компетентности, лицензии, звания или полномочий; время, проведённое на Платформе, и её результаты не могут предъявляться какой-либо организации в качестве подтверждения квалификации.",
        ],
      },
      {
        heading: "3. Заявления и обязательства пользователя",
        bullets: [
          "Пользователь обязуется использовать Платформу исключительно в законных и этических рамках, в целях развития собственной профессиональной практики.",
          "Пользователь обязуется НЕ вводить какие-либо РЕАЛЬНЫЕ данные пациента или клиента, идентифицирующие сведения либо данные о здоровье, относящиеся к особым категориям и принадлежащие какому-либо лицу; все правовые последствия таких действий несёт исключительно Пользователь.",
          "Пользователь обязуется не использовать полученные от Платформы результаты для диагностики, лечения, вмешательства или принятия клинических решений в отношении реального человека.",
          "Пользователь единолично отвечает за собственную профессиональную компетентность, объём своих полномочий и соблюдение применимых профессиональных и этических норм.",
          "Безопасность учётной записи, конфиденциальность пароля и любые действия, совершённые под учётной записью Пользователя, находятся под ответственностью Пользователя.",
          "Учётная запись является личной; Пользователь обязуется не передавать её другим лицам и не использовать Платформу с помощью автоматизированных средств (боты, скрипты и т. п.). Использование платных планов подчиняется ограничению честного использования (в настоящее время 60 сессий в календарный месяц), подробно описанному в Договоре дистанционной продажи.",
        ],
      },
      {
        heading: "4. Вся ответственность лежит на пользователе (отказ от требований)",
        paras: [
          "Платформа предоставляется «КАК ЕСТЬ» и «ПО МЕРЕ ДОСТУПНОСТИ», без каких-либо прямых или подразумеваемых гарантий (включая бесперебойную работу, отсутствие ошибок, пригодность для конкретной цели, точность или актуальность).",
          "Пользователь принимает и обязуется, что несёт ИСКЛЮЧИТЕЛЬНУЮ и ЛИЧНУЮ ответственность за любые прямые, косвенные, случайные, специальные или последующие убытки (включая имущественный и моральный вред, ущерб профессиональной репутации, утрату данных, упущенную выгоду и вред, причинённый третьим лицам), возникшие вследствие использования или невозможности использования Платформы, доверия к результатам работы ИИ либо применения таких результатов любым способом.",
          "В максимальной степени, допускаемой применимым правом, Пользователь настоящим безотзывно и безоговорочно ОТКАЗЫВАЕТСЯ — сейчас и заранее — от любых претензий, исков и прав на возмещение, которые он мог бы предъявить Платформе, её владельцам, работникам, разработчикам, деловым партнёрам и поставщикам услуг в связи с любым вредом, с которым он может столкнуться при неблагоприятном исходе.",
          "Пользователь также обязуется полностью оградить Платформу от ответственности (возместить ей) в отношении любых требований, убытков, штрафов и расходов (включая гонорары адвокатов), если к Платформе обратится третье лицо или организация по причине вины, небрежности Пользователя либо использования им Платформы с нарушением настоящих Условий.",
        ],
      },
      {
        heading: "5. Ограничение ответственности",
        paras: [
          "Без ущерба для императивных норм применимого права совокупная юридическая ответственность Платформы в любом случае ограничивается суммой, фактически уплаченной Пользователем Платформе за 12 месяцев, предшествующих событию, послужившему основанием соответствующего требования. При бесплатном использовании эта сумма равна нулю.",
        ],
      },
      {
        heading: "6. Интеллектуальная собственность, изменение и прекращение",
        bullets: [
          "Все права интеллектуальной собственности на Платформу, её программное обеспечение, дизайн, шаблоны случаев пациентов и содержание принадлежат Платформе.",
          "Все передаваемые имущественные права интеллектуальной собственности на содержание, создаваемое Пользователем на Платформе (включая написанные им реплики терапевта, стенограммы сессий и производные от них материалы), считаются переданными Платформе исключительно, бессрочно и безвозмездно в момент создания такого содержания; Платформа вправе использовать, воспроизводить и обрабатывать это содержание по всему миру и без ограничений в любых целях, включая оказание услуги, формирование обратной связи, а также улучшение и развитие системы (в том числе улучшение методами машинного обучения). Права Пользователя в отношении персональных данных согласно применимому законодательству о защите данных (GDPR / KVKK) настоящей передачей не затрагиваются и сохраняются.",
          "Платформа оставляет за собой право в любое время и без предварительного уведомления изменять, приостанавливать или прекращать действие настоящих Условий и объём услуги.",
          "В случае нарушения настоящих Условий Платформа вправе без предварительного уведомления приостановить или закрыть учётную запись.",
        ],
      },
      {
        heading: "7. Применимое право и подсудность",
        paras: [
          "Настоящие Условия регулируются правом Турецкой Республики. Споры, которые могут возникнуть, подсудны судам и органам принудительного исполнения Турецкой Республики.",
          "Для потребителей, проживающих в Европейском союзе, сохраняются гарантии, предоставляемые императивными нормами законодательства о защите прав потребителей их страны проживания, а также их права в области защиты данных по GDPR; настоящий выбор права не отменяет эти императивные нормы.",
        ],
      },
    ],
  },
  {
    id: "privacy",
    title: "Политика конфиденциальности",
    description:
      "GDPR как базовый стандарт; обрабатываемые данные, правовые основания, хостинг в ЕС, международные передачи (поставщик ИИ) и оговорка о трансграничной передаче по ст. 9 KVKK для пользователей в Турции.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          `Настоящая Политика конфиденциальности объясняет, как обрабатываются персональные данные на Платформе, управляемой ${OWNER}. В качестве базового стандарта защиты данных Политика следует Общему регламенту ЕС о защите данных (GDPR / 2016/679); для пользователей, находящихся в Турции, дополнительно применяется Закон Турции о защите персональных данных № 6698 (KVKK), в частности его статья 9 о передаче за рубеж. Уведомление по KVKK и Заявление о явном согласии являются неотъемлемой частью настоящей Политики.`,
        ],
      },
      {
        heading: "Оператор данных и место размещения",
        bullets: [
          "Оператор данных: PsyPractice. Обращения субъектов данных обрабатываются по каналу связи, указанному на Платформе (адрес для связи: info@psycora.com).",
          "Хостинг: Платформа и её база данных размещены в пределах Европейского союза — в дата-центре в Нидерландах (Oracle Cloud). Для пользователей, находящихся в ЕС/ЕЭЗ, данные обрабатываются и хранятся внутри ЕС.",
          "Поставщик хостинга выступает исключительно как обработчик на основании заключённого соглашения об обработке данных (DPA).",
        ],
      },
      {
        heading: "Собираемые данные",
        bullets: [
          "Данные учётной записи: имя, адрес электронной почты, хешированный пароль, сведения о подписке и тарифе.",
          "Данные об использовании: созданные сессии, стенограммы сессий, сгенерированные случаи пациентов, отчёты обратной связи супервизора.",
          "Технические данные: записи о сеансах, IP-адрес, языковые настройки и настройки браузера, журналы ограничения частоты запросов и безопасности.",
        ],
      },
      {
        heading: "Цели обработки и правовое основание (ст. 6 GDPR)",
        bullets: [
          "Исполнение договора (ст. 6(1)(b)): создание учётной записи, проведение сессий, сквозная память пациента, разбор супервизором, управление подпиской и лимитами использования.",
          "Законный интерес (ст. 6(1)(f)): безопасность, предотвращение злоупотреблений, улучшение системы и устранение ошибок.",
          "Правовая обязанность (ст. 6(1)(c)): хранение и отчётность, вытекающие из законодательства.",
          "Согласие (ст. 6(1)(a)): аналитика и обработка для улучшения продукта, не являющиеся строго необходимыми для оказания услуги, а также, где это требуется, передача за пределы ЕС/ЕЭЗ.",
        ],
      },
      {
        heading: "Международные передачи",
        paras: [
          "Поскольку хостинг находится в ЕС (Нидерланды), данные пользователей из ЕС/ЕЭЗ, как правило, обрабатываются внутри ЕС и на этом уровне не передаются в третьи страны. Однако для генерации ответов ИИ содержание сессий и запросы передаются поставщику ИИ-услуг (Anthropic), чья обрабатывающая инфраструктура может находиться за пределами ЕС/ЕЭЗ (например, в США).",
          "Такие передачи за пределы ЕС/ЕЭЗ опираются на надлежащие гарантии по ст. 44 и последующим статьям GDPR — в частности на Стандартные договорные условия (SCC) Европейской комиссии, — и с поставщиком заключено соглашение об обработке данных (DPA). Платформа НЕ продаёт персональные данные в маркетинговых целях; данные не передаются третьим лицам, кроме случаев, строго необходимых для оказания услуги (за исключением законных запросов компетентных органов).",
        ],
      },
      {
        heading: "Для пользователей в Турции — ст. 9 KVKK (передача за рубеж)",
        paras: [
          "Персональные данные пользователей, находящихся в Турции, передаются за пределы Турции, поскольку хостинг расположен в Нидерландах (ЕС), а также могут передаваться компании Anthropic для обработки средствами ИИ. Эти передачи подпадают под ст. 9 KVKK и опираются на надлежащие гарантии (типовой договор или обязательство, опубликованные Советом) либо, где это требуется, на ваше явное согласие. Объём, получатели и цель передачи подробно описаны в Уведомлении по KVKK и Заявлении о явном согласии.",
        ],
      },
      {
        heading: "Права субъекта данных (ст. 15–22 GDPR)",
        bullets: [
          "Доступ, исправление, удаление («право быть забытым») и ограничение обработки.",
          "Переносимость данных: получение предоставленных вами данных в структурированном, широко используемом, машиночитаемом формате.",
          "Возражение: против обработки на основании законного интереса и против прямого маркетинга.",
          "Права, связанные с принятием решений исключительно автоматизированным способом и профилированием.",
          "Отзыв согласия в любой момент для обработки на основании согласия (отзыв не влияет на законность обработки до этого момента).",
          "Право подать жалобу в надзорный орган: соответствующий орган по защите данных в ЕС; Управление по защите персональных данных (KVKK) в Турции.",
        ],
      },
      {
        heading: "Хранение и безопасность",
        bullets: [
          "Данные хранятся столько, сколько требует цель обработки, и в течение сроков, предписанных применимым законодательством; по истечении срока они удаляются или обезличиваются.",
          "Чувствительные поля (например, пароль, коды подтверждения и сброса) хранятся в зашифрованном или хешированном виде; доступ к ним предоставляется по правам.",
          "Поскольку ни один способ передачи или хранения не является на 100 % безопасным, абсолютная безопасность не может быть гарантирована.",
        ],
      },
      {
        heading: "Запрет на данные реальных пациентов",
        paras: [
          "Платформа является программой-симулятором; вводить персональные данные и данные о здоровье реальных клиентов запрещено. Всю ответственность за ввод данных в нарушение этого запрета несёт исключительно Пользователь.",
        ],
      },
    ],
  },
  {
    id: "kvkk",
    title: "Уведомление по KVKK",
    description:
      "Оператор данных, цели обработки, правовое основание, передача и права субъекта данных согласно статье 10 Закона № 6698.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Оператор данных",
        paras: [
          `В соответствии со статьёй 10 Закона Турции о защите персональных данных № 6698 («KVKK») ваши персональные данные обрабатываются ${OWNER} в качестве Оператора данных в описанном ниже объёме.`,
        ],
      },
      {
        heading: "Обрабатываемые данные и цели",
        bullets: [
          "Идентификация и контакты (имя, электронная почта): создание учётной записи, аутентификация, связь.",
          "Клиентские операции (подписка, тариф, использование): оказание услуги, выставление счетов, соблюдение лимитов.",
          "Безопасность операций (сеансы, IP, журналы): безопасность, предотвращение злоупотреблений, правовая обязанность.",
          "Содержание, созданное пользователем (стенограммы сессий, сгенерированные случаи): оказание программной услуги и формирование обратной связи.",
          "Членство в институциональной группе (идентификатор группы, период членства): при вступлении пользователя в группу, организованную учреждением, — видимость для преподавателя и администрирование группы.",
        ],
      },
      {
        heading: "Правовое основание (ст. 5)",
        bullets: [
          "Заключение и исполнение договора: данные, необходимые для оказания услуги.",
          "Законный интерес оператора данных: безопасность, предотвращение мошенничества, улучшение системы.",
          "Правовая обязанность: хранение и отчётность, вытекающие из законодательства.",
          "Явное согласие: передача за рубеж (ст. 9) и дополнительная обработка, не являющаяся строго необходимой для оказания услуги.",
        ],
      },
      {
        heading: "Передача за рубеж (ст. 9)",
        paras: [
          "Поскольку Платформа и её база данных размещены в пределах Европейского союза — в дата-центре в Нидерландах (Oracle Cloud), — персональные данные пользователей, находящихся в Турции, передаются за пределы Турции (в ЕС). Кроме того, для генерации ответов ИИ содержание сессий и запросы могут передаваться поставщику ИИ-услуг (Anthropic), чья обрабатывающая инфраструктура может находиться за пределами ЕС/ЕЭЗ (например, в США).",
          "Эти передачи за рубеж подпадают под ст. 9 KVKK и опираются на надлежащие гарантии — такие как типовой договор или обязательство, опубликованные Советом, — либо, где это требуется, на ваше явное согласие. С поставщиками хостинга и услуг заключены соглашения об обработке данных (DPA).",
        ],
      },
      {
        heading: "Институциональные группы и видимость для преподавателя",
        paras: [
          "Если вы вступаете в группу, открытую университетом, клиникой или подобным учреждением, содержание ваших сессий (стенограммы) и отчёты супервизора могут быть доступны преподавателю этой группы в течение всего срока её работы. Эта видимость охватывает только ваши сессии, относящиеся к группе, и прекращается по окончании вашего членства в ней.",
          "Такой доступ предоставляется через ОТДЕЛЬНЫЙ экран явного согласия, показываемый при вступлении в группу; он не входит в общее принятие условий Платформы. Если вы не дадите это согласие, вы не сможете вступить в группу, но сможете продолжать пользоваться Платформой индивидуально ровно так же, как прежде. Отзыв согласия прекращает ваше членство в группе и не затрагивает индивидуальное использование.",
        ],
      },
      {
        heading: "Права субъекта данных (ст. 11)",
        bullets: [
          "Узнать, обрабатываются ли ваши персональные данные, и, если да, запросить информацию.",
          "Узнать цель обработки и используются ли данные в соответствии с этой целью.",
          "Знать третьих лиц, которым данные передаются внутри страны или за рубеж.",
          "Требовать исправления неполной или неверной обработки и, при соблюдении условий, удаления или уничтожения данных.",
          "Возражать против неблагоприятного для вас результата, возникшего исключительно вследствие автоматизированного анализа.",
          "Требовать возмещения вреда, причинённого неправомерной обработкой.",
        ],
      },
      {
        heading: "Обращения",
        paras: [
          "Обращения по поводу ваших прав можно направлять по каналу связи, объявленному Оператором данных. Обращения рассматриваются в сроки, предписанные KVKK и подзаконными актами к нему.",
        ],
      },
    ],
  },
  {
    id: "consent",
    title: "Заявление о явном согласии",
    description:
      "Отдельно от уведомления; свободно данное согласие на передачу за рубеж и обработку средствами ИИ.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "Я заявляю, что прочитал(а) и понял(а) Уведомление по KVKK и что свободно, осознанно и явно даю согласие на описанную ниже обработку. (Согласно решению Совета по защите персональных данных № 2018/90 явное согласие получается отдельно от исполнения обязанности по информированию.)",
        ],
      },
      {
        heading: "Обработка, на которую даётся согласие",
        bullets: [
          "Передача моих персональных данных за пределы Турции, а также их хранение и обработка там, поскольку Платформа размещена в Европейском союзе (Нидерланды / Oracle Cloud) (ст. 9 KVKK).",
          "Передача и обработка стенограмм моих сессий и запросов у поставщика ИИ-услуг (Anthropic), чья обрабатывающая инфраструктура может находиться за пределами ЕС/ЕЭЗ, в целях генерации ответов ИИ (ст. 9 KVKK).",
          "Обработка в целях улучшения продукта и аналитики, не являющаяся строго необходимой для оказания услуги.",
          "Получение уведомлений, связанных с услугой.",
        ],
      },
      {
        heading: "Отзыв согласия",
        paras: [
          "Я понимаю, что могу отозвать своё явное согласие в любой момент; однако, поскольку передача за рубеж поставщику ИИ технически необходима для работы услуги, я принимаю, что отзыв этого согласия может привести к невозможности пользоваться соответствующими функциями или услугой в целом. Отзыв не влияет на законность обработки, осуществлённой до даты отзыва.",
        ],
      },
    ],
  },
  {
    // TR/EN "outreach" bildiriminin karşılığı — oradaki yoruma bakınız.
    id: "outreach",
    title: "Уведомление о рассылке обращений",
    description:
      "Для преподавателей и институциональных контактов, получивших корпоративное письмо-обращение: откуда взяты данные, зачем они обрабатываются, правовое основание и как отказаться.",
    updated: "2026-08-06",
    sections: [
      {
        paras: [
          "Настоящее уведомление адресовано получателям корпоративных писем-обращений, которые PsyPractice направляет кафедрам психологии университетов и их преподавателям, и составлено в соответствии со статьёй 10 Закона Турции о защите персональных данных № 6698 (KVKK) и Коммюнике о порядке и принципах исполнения обязанности по информированию. Поскольку ваши персональные данные получены не непосредственно от вас, информирование осуществляется не позднее момента первого обращения — именно поэтому письмо содержит ссылку сюда.",
        ],
      },
      {
        heading: "1. Оператор данных",
        bullets: [
          `Наименование: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Адрес: ${MERCHANT.addressEn}`,
          `Налоговая инспекция / ИНН: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `Электронная почта: ${MERCHANT.email}`,
          `Сайт: ${MERCHANT.website}`,
        ],
      },
      {
        heading: "2. Обрабатываемые данные и их источник",
        paras: [
          "Обработка ограничивается профессиональными контактными данными: имя, учёное звание, университет и кафедра, институциональный адрес электронной почты и, если он опубликован, институциональный номер телефона.",
          "Эти данные собраны не у вас, а составлены по общедоступным официальным страницам кафедр и факультетов университетов. Данные особых категорий не обрабатываются, а частные (не институциональные) адреса электронной почты для обращений не используются.",
        ],
      },
      {
        heading: "3. Цель",
        paras: [
          "Ваши данные обрабатываются, чтобы представить программный инструмент, созданный для подготовки психологов, пригласить вашу кафедру к разговору о возможном пилоте или сотрудничестве и вести связанную с этим переписку. Они не используются ни для каких иных целей, не продаются и не передаются третьим лицам для маркетинга.",
        ],
      },
      {
        heading: "4. Правовое основание",
        paras: [
          "Обработка опирается на законные интересы оператора данных согласно статье 5/2-(f) KVKK при условии, что это не наносит ущерба вашим основным правам и свободам: обращение направляется только на институциональный адрес, только по вопросу, непосредственно связанному с профессиональной сферой получателя, и ограниченное число раз.",
          "Сам по себе факт общедоступности данных в интернете не является правовым основанием. Совет по защите персональных данных указал, что общедоступность данных не делает их пригодными для любой цели и что намерение и цель их обнародования должны оцениваться отдельно; поэтому статья 5/2-(d) не используется в качестве основания.",
        ],
      },
      {
        heading: "5. Передача и хранение",
        paras: [
          "Переписка ведётся через поставщика электронной почты, инфраструктура которого может находиться за рубежом; такие передачи осуществляются с надлежащими гарантиями согласно статье 9 KVKK.",
          "Ваши данные удаляются по достижении цели обращения или по вашему запросу. После запроса на удаление сохраняется строго ограниченная запись «не связываться», единственное назначение которой — гарантировать, что к вам больше не обратятся; для рассылок она никогда не используется.",
        ],
      },
      {
        heading: "6. Коммерческие электронные сообщения и право на отказ",
        paras: [
          "Рекламные сообщения подпадают под действие Закона № 6563 о регулировании электронной торговли. Вы можете отказаться от их получения без объяснения причин; отказы обрабатываются не позднее трёх рабочих дней, после чего рекламные сообщения больше не направляются. Достаточно ответить на полученное письмо или написать на " + MERCHANT.email + ".",
        ],
      },
      {
        heading: "7. Ваши права",
        paras: [
          "Согласно статье 11 KVKK вы вправе узнать, обрабатываются ли ваши персональные данные, запросить о них информацию, узнать цель обработки и используются ли они в соответствии с ней, знать третьих лиц, которым они передаются в Турции или за рубежом, требовать исправления неполных или неточных данных, требовать их удаления или уничтожения, требовать уведомления об этих действиях третьих лиц, возражать против неблагоприятного для вас результата, полученного исключительно автоматизированным анализом, и требовать возмещения причинённого вреда.",
          `Запросы можно направлять на ${MERCHANT.email}; ответ даётся не позднее тридцати дней. За вами также сохраняется право подать жалобу в Совет по защите персональных данных.`,
        ],
      },
    ],
  },
  {
    id: "cookies",
    title: "Политика в отношении файлов cookie",
    description: "Виды используемых файлов cookie, их назначение и управление настройками.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "Платформа использует файлы cookie и аналогичные технологии локального хранения (localStorage), чтобы поддерживать ваш сеанс и запоминать ваши настройки.",
        ],
      },
      {
        heading: "Используемые технологии",
        bullets: [
          "Строго необходимые: токен сеанса и аутентификации, безопасность. Без них услуга не работает.",
          "Функциональные: настройка языка и локали (NEXT_LOCALE), настройки интерфейса (например, тема).",
          "Производительность и безопасность: технические журналы для ограничения частоты запросов и выявления злоупотреблений.",
        ],
      },
      {
        heading: "Управление настройками",
        paras: [
          "Вы можете удалить или заблокировать файлы cookie в браузере; однако блокировка строго необходимых файлов cookie сделает невозможным вход и работу основных функций. В соответствии с принципами GDPR / ePrivacy и Руководством KVKK по файлам cookie неосновные файлы cookie используются только на основании вашего явного выбора или согласия.",
        ],
      },
    ],
  },
  {
    id: "about",
    title: "О нас",
    description:
      "Назначение PsyPractice, предоставляемая услуга и контактные данные продавца.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "PsyPractice — это платформа симуляции пациента и отработки клинических навыков на базе искусственного интеллекта, созданная для студентов-психологов и недавних выпускников, начинающих клиническую практику. Пользователи проводят текстовые терапевтические сессии; по завершении каждой сессии ИИ-супервизор разбирает разговор и составляет развивающий отчёт обратной связи. ИИ-пациент переносит терапевтические отношения от сессии к сессии благодаря сквозной памяти.",
        ],
      },
      {
        heading: "Наша миссия",
        paras: [
          "Наша цель — дать будущим специалистам в области психического здоровья безопасную и повторяемую среду, где можно отрабатывать навыки клинической беседы без какого-либо риска навредить реальным клиентам. PsyPractice не является образовательной или преподавательской услугой; это программный инструмент, который позволяет пользователю вести и фиксировать собственную практику. Это не реальная терапия или консультирование, это не замена клинической супервизии, это не диагностический или оценочный инструмент, и это нельзя использовать в кризисных или неотложных ситуациях.",
        ],
      },
      {
        heading: "Что мы предлагаем",
        bullets: [
          "Симуляция текстовых терапевтических сессий с разнообразными профилями пациентов, синтезированными из клинической литературы.",
          "Автоматические отчёты разбора супервизора после каждой сессии.",
          "Модель «живого пациента» со сквозной памятью, благодаря которой терапевтические отношения развиваются во времени.",
          "Создание собственных пациентов: студент может сгенерировать свой ИИ-случай.",
          "Метрики прогресса, отслеживающие развитие микронавыков.",
        ],
      },
      {
        heading: "Сведения о продавце",
        bullets: [
          `Наименование: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Адрес: ${MERCHANT.addressEn}`,
          `Налоговая инспекция / ИНН: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `Электронная почта: ${MERCHANT.email}`,
          `Сайт: ${MERCHANT.website}`,
        ],
      },
    ],
  },
  {
    id: "distance-sales",
    title: "Договор дистанционной продажи",
    description:
      "Продавец, покупатель, услуга, цена, оплата, исполнение и условия права на отказ согласно Закону Турции № 6502 и Положению о дистанционных договорах.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Стороны",
        bullets: [
          `ПРОДАВЕЦ: ${MERCHANT.legalName} (${OWNER_TYPE}). Адрес: ${MERCHANT.addressEn}. Налоговая инспекция / ИНН: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}. Электронная почта: ${MERCHANT.email}.`,
          "ПОКУПАТЕЛЬ: физическое или юридическое лицо, создающее учётную запись на Платформе и приобретающее платную подписку (далее — «Покупатель»).",
        ],
      },
      {
        heading: "2. Предмет договора",
        paras: [
          "Предметом настоящего Договора является определение прав и обязанностей сторон в соответствии с Законом Турции № 6502 о защите прав потребителей и Положением о дистанционных договорах в отношении продажи и исполнения подписки на цифровую услугу, приобретённой Покупателем на Платформе в электронной форме, характеристики и цена которой указаны ниже.",
        ],
      },
      {
        heading: "3. Характер услуги и цена",
        bullets: [
          "Продаваемая услуга — это функции симуляции пациента на базе ИИ, предоставляемые в рамках платного тарифного плана программного обеспечения PsyPractice (цифровая услуга / право пользования программой).",
          "PsyPractice не является образовательной или преподавательской услугой; это программный инструмент, который позволяет пользователю вести и фиксировать собственную практику. Плата за подписку — это встречное предоставление за доступ к этой программе; это не плата за занятия, учебную программу, экзамены, консультации или какой-либо документ.",
          "Содержание плана, срок (месячный, 4-месячный период или годовой) и действующая цена чётко отображаются на странице цен/оплаты Платформы в момент покупки; итоговая сумма с учётом налогов сообщается Покупателю до оплаты.",
          "Цены действуют в валюте, отображаемой на Платформе; если подписка не отменена, она автоматически продлевается по той же цене по окончании выбранного срока.",
          "В планах, предлагаемых как «безлимитные сессии», использование подчиняется ограничению честного использования (в настоящее время 60 сессий в календарный месяц). После достижения ограничения новые сессии можно снова начинать с первого дня следующего календарного месяца; это не даёт права на снижение цены или возврат средств. Ограничение служит для предотвращения совместного использования учётных записей и автоматизированного использования, и Продавец не изменяет его в ущерб Покупателю в течение оплаченного периода подписки.",
        ],
      },
      {
        heading: "4. Оплата",
        paras: [
          "Платежи по кредитным и дебетовым картам принимаются в защищённом режиме через лицензированную платёжную организацию iyzico. Данные карты Продавцом не хранятся; платёж обрабатывается в защищённых системах iyzico. При повторяющихся (подписочных) платежах сумма автоматически списывается в каждом периоде продления с карты, одобренной Покупателем.",
        ],
      },
      {
        heading: "5. Исполнение и предоставление",
        paras: [
          "Услуга является цифровой и не предполагает физической доставки. После подтверждения платежа функции подписки становятся доступны в учётной записи Покупателя незамедлительно. Исполнение осуществляется в электронной форме путём предоставления бесперебойного доступа в течение всего срока подписки.",
        ],
      },
      {
        heading: "6. Право на отказ и исключение из него",
        bullets: [
          "Согласно статье 15/1-(ğ) Положения о дистанционных договорах право на отказ не может быть реализовано в отношении нематериальных (цифровых) товаров и услуг, исполняемых мгновенно в электронной форме, если исполнение начато с согласия Покупателя.",
          "Покупатель в момент покупки признаёт, что услуга будет исполнена немедленно и что, следовательно, право на отказ отсутствует. Покупатель может в любой момент отменить подписку, чтобы прекратить продление; отмена вступает в силу по окончании текущего оплаченного периода.",
          "Подробные условия возврата см. в разделе «Условия предоставления услуги и возврата».",
        ],
      },
      {
        heading: "7. Споры и вступление в силу",
        paras: [
          "В случае спора Покупатель может обратиться в Потребительскую арбитражную комиссию или в потребительские суды по месту своего жительства в пределах денежных лимитов, объявленных Министерством торговли. Настоящий Договор считается заключённым и вступает в силу с момента его одобрения Покупателем в электронной форме.",
        ],
      },
    ],
  },
  {
    id: "delivery-refund",
    title: "Условия предоставления услуги и возврата",
    description:
      "Предоставление цифровой услуги, отмена подписки, исключение из права на отказ и условия возврата средств.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Предоставление (цифровая услуга)",
        bullets: [
          "PsyPractice — полностью цифровая услуга; физической отправки товара или курьерской доставки не существует.",
          "В момент подтверждения платежа функции подписки активируются в учётной записи Покупателя автоматически и мгновенно; отдельного срока предоставления или платы за доставку нет.",
          "Доступ к услуге осуществляется через веб-браузер любого устройства с подключением к интернету.",
        ],
      },
      {
        heading: "Отмена подписки",
        bullets: [
          "Покупатель может отменить подписку в любой момент в настройках учётной записи. Отмена вступает в силу по окончании текущего оплаченного периода и прекращает следующее автоматическое продление.",
          "После отмены доступ к услуге сохраняется до конца оплаченного периода.",
        ],
      },
      {
        heading: "Право на отказ и возврат средств",
        bullets: [
          "Поскольку услуга является цифровой и исполняется немедленно с согласия Покупателя, по общему правилу право на отказ — а значит, и право на возврат — согласно статье 15/1-(ğ) Положения о дистанционных договорах не возникает.",
          "В случаях явного недостатка — например, ошибочного или двойного списания, полной невозможности получить доступ к услуге по техническим причинам и тому подобного — Покупатель может запросить возврат средств, обратившись к Продавцу в разумный срок с даты платежа.",
          `Запросы на возврат направляются на ${MERCHANT.email}; одобренные возвраты перечисляются на карту, использованную для оплаты, через инфраструктуру iyzico, как правило, в течение 14 дней. Срок возврата может отличаться в зависимости от времени обработки банком.`,
        ],
      },
      {
        heading: "Контакты",
        paras: [
          `По всем вопросам предоставления услуги, отмены и возврата: ${MERCHANT.email}${MERCHANT.phone ? " · " + MERCHANT.phone : ""}.`,
        ],
      },
    ],
  },
];
